import { Injectable } from '@angular/core';

import { AppState } from '../app-state';

import { RestClient } from './rest-client';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { ImportFile } from '../models/import-file';
import { AppErrorMessageEvent } from '..';
import { LocationLogRecord } from '../models/location-log-record';
import { CallLogRecord } from '../models/call-log-record'
import { TmoLocationLogRecord } from '../models/tmo-location-log-record';
import { CorrelationRecord } from '../models/correlation-record';
import { CorrelationDashboardRecord, CorrelationSummaryRecord, CorrelationSummaryByPointRecord, Stage, Building, BuildingStageView,Route } from '../models';
import { CorrelationSummaryByPathRecord } from '../models/correlation-summary-by-path-record';
import { DialerCallLogRecord } from '../models/dialer-call-log-record'
import { TableViewFilter, TableViewQueryCriteria, TableViewQueryResponse } from '../../shared/components/table-view/table-view-component-base';
import { Handset } from '../models/handset';
import { RutCallLogViewRecord } from '../models/rut-call-log-record';
import { firstValueFrom } from 'rxjs';
import { saveAs } from 'file-saver';




export class LocationLog {

    records: LocationLogRecord[] = []
}

export class PostProcessingRestClient extends RestClient<LocationLog> {

    constructor(http: HttpClient, appState: AppState) {
        super(http, 'postProcessing', appState)
    }

}


export class PostProcessingImportType {
    public requiresStage?: boolean
    public acceptsStage?: boolean // allows stage selection but doesn't require it
    public supportsRejections?: boolean; // newer location logs supports ignoring rejected records (duplicates, etc...)

    constructor(
        public carrierId: 'tmo'|'att'|'vzw'|'ggl'|'dish'|'rypplzz'|null,
        public name: string,
        public urlSubPath: string,
        public formData: { [key:string]: string },
        public fileExtensions?: string[]
    ){}
}

export interface TestSeqImportJobCriteria {
    stage? : string
    participant? : string
    buildingid? : string
    routeid? : string
}

export class TestSeqResult {
    testSeqId: string
    importTime: string
    callCnt: number
    ok: boolean
    msg: string
}
export class TestSeqImportJobResp {
    results: TestSeqResult[] // more than one testseq record may have been processed so need array of results
    okCnt: number
    failCnt: number
    correlationViewUpdated: boolean
    msg: string
}

type RestImportResponse<ResultPayloadType> = {
    code: number,
    msg: string,
    data: ResultPayloadType
};

export type LogImportResult = {
    counts: {
      imported: number;
      skipped: number;
      rejected: number;
    };
    wsHeaders: string[];
    rejections?: {
        guardType: string;
        message: string;
        entity: any; // the transformed value that was rejected
        wsRow: Array<string | number | boolean> // the source row from csv or excel
    }[];
};

export type ImportFileArgs = {
    abortOnRejections: boolean; // don't commit imported rows if any of them are rejected
    file: File;
    importType: PostProcessingImportType;
    stage: Stage;
    route:Route;
    building: Building;
    progressSetter: (progress: number) => void;

    // baro log specific (workaround for new baro logs using UTC but db wants building local time)
    baroUtcToBuildingLocalTime?: boolean;
};


@Injectable({ providedIn: 'root' })
export class PostProcessingService {

    // readonly tmoLocationLog1dImport = {
    //     carrierId: 'tmo',
    //     name: 'T-Mobile Location Log (1d)',
    //     urlSubPath: `locationLog/tmo`,
    //     formData: { format: '1d' },
    //     requiresStage: true
    // } as PostProcessingImportType

    // readonly tmoLocationLog1eImport = {
    //     carrierId: 'tmo',
    //     name: 'T-Mobile Location Log (2020)',
    //     urlSubPath: `locationLog/tmo`,
    //     formData: { format: '2020' },
    //     requiresStage: true
    // } as PostProcessingImportType

    // readonly tmoLocationLog2021Import = {
    //     carrierId: 'tmo',
    //     name: 'T-Mobile Location Log (2021)',
    //     urlSubPath: `locationLog/tmo`,
    //     formData: { format: '2021' },
    //     requiresStage: true
    // } as PostProcessingImportType

    readonly tmoLocationLog2023Import = {
        carrierId: 'tmo',
        name: 'T-Mobile Location Log',
        urlSubPath: `locationLog/tmo`,
        formData: { format: '2023' },
        requiresStage: true,
        supportsRejections: true,
    } as PostProcessingImportType
    // readonly tmoLocationLog2025Import = {
    //     carrierId: 'tmo',
    //     name: 'T-Mobile Location Log',
    //     urlSubPath: `locationLog/tmo`,
    //     formData: { format: '2025' },
    //     requiresStage: true,
    //     supportsRejections: true,
    // } as PostProcessingImportType

    // readonly vzwLocationLog2021Import = {
    //     carrierId: 'vzw',
    //     name: 'Verizon Location Log (2021)',
    //     urlSubPath: 'locationLog/vzw',
    //     formData: { format: '2021' },
    //     requiresStage: true,
    //     supportsRejections: true,
    // } as PostProcessingImportType

    // readonly vzwLocationLog2023Import = {
    //     carrierId: 'vzw',
    //     name: 'Verizon Location Log (2023)',
    //     urlSubPath: 'locationLog/vzw',
    //     formData: { format: '2023' },
    //     requiresStage: true,
    //     supportsRejections: true,
    // } as PostProcessingImportType

    readonly vzwLocationLog2024Import = {
        carrierId: 'vzw',
        name: 'Verizon Location Log',
        urlSubPath: 'locationLog/vzw',
        formData: { format: '2024' },
        requiresStage: true,
        supportsRejections: true,
    } as PostProcessingImportType

    // readonly attLocationLog2021Import = {
    //     carrierId: 'att',
    //     name: 'AT&T Location Log (2021)',
    //     urlSubPath: 'locationLog/att',
    //     formData: { format: '2021' },
    //     requiresStage: true
    // } as PostProcessingImportType

    // readonly attLocationLog2023Import = {
    //     carrierId: 'att',
    //     name: 'AT&T Location Log (2023)',
    //     urlSubPath: 'locationLog/att',
    //     formData: { format: '2023' },
    //     requiresStage: true,
    //     supportsRejections: true,
    // } as PostProcessingImportType

    readonly attLocationLog2024Import = {
        carrierId: 'att',
        name: 'AT&T Location Log',
        urlSubPath: 'locationLog/att',
        formData: { format: '2024' },
        requiresStage: true,
        supportsRejections: true,
    } as PostProcessingImportType

    // readonly gglLocationLog2021Import = {
    //     carrierId: 'ggl',
    //     name: 'Google Location Log',
    //     urlSubPath: 'locationLog/ggl',
    //     formData: { format: '2021' },
    //     requiresStage: true
    // } as PostProcessingImportType

    readonly gglLocationLog2025Import = {
        carrierId: 'ggl',
        name: 'Google Location Log (JSON)',
        urlSubPath: 'locationLog/ggl',
        formData: { format: '2025' },
        requiresStage: true,
        fileExtensions: ['.json'],
    } as PostProcessingImportType

    // readonly dishLocationLog2022Import = {
    //     carrierId: 'dish',
    //     name: 'Dish Location Log (2022)',
    //     urlSubPath: 'locationLog/dish',
    //     formData: { format: '2022' },
    //     requiresStage: true,
    // } as PostProcessingImportType

    readonly dishLocationLog2023Import = {
        carrierId: 'dish',
        name: 'Dish Location Log',
        urlSubPath: 'locationLog/dish',
        formData: { format: '2023' },
        requiresStage: true,
        supportsRejections: true,
    } as PostProcessingImportType

    readonly nxtNavLocationLog2023Import = {
        carrierId: 'dish',
        name: 'NextNav Location Log',
        urlSubPath: `locationLog/dish`,
        formData: { format: '2023' },
        requiresStage: true
    } as PostProcessingImportType

    readonly rypplzzLocationLog2025Import = {
        carrierId: 'rypplzz', // not really a carrier but might need this info
        name: 'Rypplzz Location Log',
        urlSubPath: `locationLog/rypplzz`,
        formData: { format: '2025' },
        requiresStage: true
    } as PostProcessingImportType

    readonly lmaCallLogImport = {
        carrierId: null,
        name: 'LMA Call Log',
        urlSubPath: `callLog`,
        formData: {},
        requiresStage: true
    } as PostProcessingImportType

    readonly baroCallLogImport = {
        carrierId: null,
        name: 'Baro Log',
        urlSubPath: 'baroLog',
        formData: {},
        requiresStage: true
    } as PostProcessingImportType

    readonly gpsLogImport = {
        carrierId: null,
        name: 'GPS Log',
        urlSubPath: 'gpsLog',
        formData: {},
        requiresStage: true
    } as PostProcessingImportType

    readonly oneSourceMasterTrackerImport = {
        carrierId: null,
        name: 'One Source Master Tracker',
        urlSubPath: 'oneSource',
        formData: {},
        requiresStage: false
    } as PostProcessingImportType

    readonly handsetsImport = {
        carrierId: null,
        name: 'Handsets',
        urlSubPath: 'handset',
        formData: {},
        requiresStage: false
    } as PostProcessingImportType

    readonly volunteersImport={
        carrierId:null,
        name:'Volunteers',
        urlSubPath:'volunteer',
        formData:{},
        requiresStage:false
    } as PostProcessingImportType

    readonly antennaImport={
        carrierId: 'rypplzz',
        name:'Rypplzz Antennas',
        urlSubPath:'antenna/rypplzz',
        formData:{},
        acceptsStage:true,
        fileExtensions: ['.csv', '.xlsx']
    } as PostProcessingImportType

    readonly ImportTypes: PostProcessingImportType[] = [
        //this.tmoLocationLog1dImport,
        //this.tmoLocationLog1eImport,
        //this.tmoLocationLog2021Import,
        this.tmoLocationLog2023Import,
        //this.tmoLocationLog2025Import,
        //this.attLocationLog2021Import,
        //this.attLocationLog2023Import,
        this.attLocationLog2024Import,
        //this.vzwLocationLog2021Import,
        //this.vzwLocationLog2023Import,
        this.vzwLocationLog2024Import,
        this.gglLocationLog2025Import,
        //this.dishLocationLog2022Import,
        this.dishLocationLog2023Import,
        this.rypplzzLocationLog2025Import,
        this.lmaCallLogImport,
        this.baroCallLogImport,
        this.handsetsImport,
        this.oneSourceMasterTrackerImport,
        this.gpsLogImport,
        this.volunteersImport,
        this.nxtNavLocationLog2023Import,
        this.antennaImport,
    ]

    httpClient: PostProcessingRestClient


    constructor(public appState: AppState, http: HttpClient) {
        this.httpClient = new PostProcessingRestClient(http, appState)
    }

    importLogFile( args: ImportFileArgs ) {
        console.log('importLogFile'+ args.file.name)
        return this.importFile<LogImportResult>(args)
    };

    importFile<DataPayloadType>(
        {abortOnRejections, baroUtcToBuildingLocalTime, file, importType, stage, route, building, progressSetter}: ImportFileArgs
    ): Promise<RestImportResponse<DataPayloadType>> {
        console.log('importFile ' + file.name)

        const uploadFailed = (msg: string) => {
        }

        var formData: any = new FormData();
        formData.append("file", file);
        if ( stage ) {
            formData.append("stageName", stage.name)
        }
        if ( building ) {
            formData.append("buildingId", building.id)
        }
        if( route ) {
            formData.append("routeId",route.id)
        }
        formData.append("abortOnRejections", abortOnRejections);
        formData.append("userId", this.appState.getUser()._id)
        if ( baroUtcToBuildingLocalTime !== undefined ) {
            formData.append("baroUtcToBuildingLocalTime", baroUtcToBuildingLocalTime);
        }
        Object.keys(importType.formData).forEach(formKey=>formData.append(formKey,importType.formData[formKey]))

        return new Promise(async (resolve,reject) => {
            this.httpClient.http.post(
                `${this.httpClient.urlPath}/importFile/import/${importType.urlSubPath}`,
                formData, { reportProgress: true, observe: 'events' }
            ).subscribe({
                next: async (event: HttpEvent<any>) => {
                    switch (event.type) {
                        case HttpEventType.Sent:
                            //console.log('importFile() HttpEventType.Sent');
                            break;
                        case HttpEventType.ResponseHeader:
                            //console.log('importFile() HttpEventType.ResponseHeader');
                            break;
                        case HttpEventType.UploadProgress:
                            let progress = Math.round(event.loaded / event.total * 100)
                            //console.log( 'importFile() HttpEventType.UploadProgress - loaded: ' +  event.loaded + ', total: ' + event.total + ' ' + progress + '%')
                            progressSetter(progress);
                            break;
                        case HttpEventType.Response:
                            if (event.status != 200) {
                                const msg = 'Server: ' + event.statusText
                                console.error('importFile() HttpEventType.Response: ' + msg)
                                progressSetter(0)
                                this.appState.publishError('Failed importing "' + file.name + '" (' + msg + ')', this)
                                uploadFailed(msg)
                                reject(new Error(msg))
                            } else {
                                progressSetter(0)
                                resolve(event.body)
                            }
                    }
                },
                error: async err => {
                    let msg = this.httpClient.extractErrorMsg(err)
                    if (!msg) {
                        msg = 'File import failed for ' + file.name
                    }
                    progressSetter(0)
                    uploadFailed(msg)
                    reject(err)
                }
            })
        })
    }


    async runTestSeqImportJob( importFilter : TestSeqImportJobCriteria ) : Promise<TestSeqImportJobResp> {
        try {
            const result : any = await this.httpClient.http.post<TestSeqImportJobCriteria>(
                `${this.httpClient.urlPath}/dialerCallLog/runTestSeqImport`, importFilter, { observe: 'response' }).toPromise()
            const resp : TestSeqImportJobResp = result.body?.data
            console.log( JSON.stringify(resp))
            return resp
        } catch (error) {
            console.error('testSeqImport() error: ' + error?.message )
            this.publishError(error,this)
            throw error
        }
    }


    async findImportFiles( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/importFile/find`, { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<ImportFile> = result.data
            return resp
        } catch (error) {
            console.error('findImportFiles() error: ' + error?.message )
            throw error
        }
    }

    async deleteImportFile( params : {fileId:string,fileName:string,tableName:string} ) {
        try {
            const result: any = await this.httpClient.http.delete(
                `${this.httpClient.urlPath}/importFile/delete`, { params }).toPromise()
            const resp : TableViewQueryResponse<ImportFile> = result.data
            return resp
        } catch (error) {
            console.error('deleteImportFile() error: ' + error?.message)
            throw error
        }
    }

    async getImportFileTableEarliestAndLatestCallLocationTime(params : {fileId:string,tableName:string}) {
        try {
            const result: any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/importFile/getEarliestAndLatestCallTime`, { params }).toPromise()
            return result.data
        } catch (error) {
            console.error('deleteImportFile() error: ' + error?.message)
            throw error
        }
    }
    async getImportFileTableRowCount(params : {fileId:string,tableName:string}) {
        try {
            const result: any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/importFile/rowCount`, { params }).toPromise()
            return result.data
        } catch (error) {
            console.error('deleteImportFile() error: ' + error?.message)
            throw error
        }
    }


    async findLocationLogRecords( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/locationLog/find`,
                { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<LocationLogRecord> = result.data
            return resp
        } catch (error) {
            console.error('findLocationLogRecords() error: ' + error?.message )
            throw error
        }
    }

    async findCallLogRecords( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/callLog/find`,
                { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<CallLogRecord> = result.data
            return resp
        } catch (error) {
            console.error('findCallLogRecords() error: ' + error?.message )
            throw error
        }
    }

    async findDialerCallLogRecords( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/dialerCallLog/find`,
                { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<DialerCallLogRecord> = result.data
            return resp
        } catch (error) {
            console.error('findDialerCallLogRecords() error: ' + error?.message )
            throw error
        }
    }

    async findRutCallLogRecords( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await firstValueFrom(this.httpClient.http.get(
                `${this.httpClient.urlPath}/rutCallLogView/find`,
                { params: {criteria: JSON.stringify(queryCriteria)} }))
            const resp : TableViewQueryResponse<RutCallLogViewRecord> = result.data
            return resp
        } catch (error) {
            console.error('findRutCallLogRecords() error: ' + error?.message )
            throw error
        }
    }

    async findTmoLocationLogRecords( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/tmoLocationLog/find`,
                { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<TmoLocationLogRecord> = result.data
            return resp
        } catch (error) {
            console.error('findTmoLocationLogRecords() error: ' + error?.message )
            throw error
        }
    }


    async findCorrelationRecords( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/correlation/find`,
                { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<CorrelationRecord> = result.data
            return resp
        } catch (error) {
            console.error('findCorrelationRecords() error: ' + error?.message )
            throw error
        }
    }


    async findCorrelationDashboardRecords( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/correlationDashboard/find`, { params:
                    {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<CorrelationDashboardRecord> = result.data
            return resp
        } catch (error) {
            console.error('findCorrelationDashboardRecords() error: ' + error?.message )
            throw error
        }
    }

    async correlationDashboardDistinctParticipants() {
        try {
            const strUrl = `${this.httpClient.urlPath}/correlationDashboard/distinctParticipants`;
            const result : any = await firstValueFrom(
                this.httpClient.http.get(strUrl)
            );
            const participants = result.data
            return participants
        } catch (error) {
            console.error('correlationDashboardDistinctParticipants() error: ' + error?.message )
            throw error
        }
    }

    async correlationDashboardDistinctParticipantStages(participant: string) {
        try {
            const strUrl = `${this.httpClient.urlPath}/correlationDashboard/distinctParticipantStages/${participant}`;
            const result : any = await firstValueFrom(
                this.httpClient.http.get(strUrl)
            );
            const stages = result.data
            return stages
        } catch (error) {
            console.error('correlationDashboardDistinctParticipantStages() error: ' + error?.message )
            throw error
        }
    }


    async findCorrelationSummaryRecords( queryCriteria : TableViewQueryCriteria ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/correlationSummary/find`, { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<CorrelationSummaryRecord> = result.data
            return resp
        } catch (error) {
            console.error('findCorrelationSummaryRecords() error: ' + error?.message )
            throw error
        }
    }


    async findCorrelationSummaryByPathRecords( queryCriteria : TableViewQueryCriteria  ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/correlationSummaryByPath/find`,{ params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<CorrelationSummaryByPathRecord> = result.data
            return resp
        } catch (error) {
            console.error('findCorrelationSummaryByPathRecords() error: ' + error?.message )
            throw error
        }
    }


    async findCorrelationSummaryByPointRecords( queryCriteria : TableViewQueryCriteria  ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/correlationSummaryByPoint/find`, { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<CorrelationSummaryByPointRecord> = result.data
            return resp
        } catch (error) {
            console.error('findCorrelationSummaryByPointRecords() error: ' + error?.message )
            throw error
        }
    }

    async findBuildingStages( queryCriteria : TableViewQueryCriteria = null ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/buildingStages/find`, { params: {criteria: JSON.stringify(queryCriteria||{}) }}).toPromise()
            const resp : TableViewQueryResponse<BuildingStageView> = result.data
            return resp
        } catch (error) {
            console.error('findBuildingStages() error: ' + error?.message )
            throw error
        }
    }

    //TBD - can we use couchdb buildings collection instead of this?
    async findBuildings( queryCriteria : TableViewQueryCriteria ) {
        console.log('findBuildings()')
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlBasePath}/building/find`, { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<Building> = result.data
            return resp
        } catch (error) {
            console.error('findBuildings() error: ' + error?.message )
            throw error
        }
    }

    async findHandsets( queryCriteria : TableViewQueryCriteria = null ) {
        try {
            const result : any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/handset/find`, { params: {criteria: JSON.stringify(queryCriteria||{}) }}).toPromise()
            const resp : TableViewQueryResponse<Handset> = result.data
            return resp
        } catch (error) {
            console.error('findHandsets() error: ' + error?.message )
            throw error
        }
    }

    async downloadRollupSummary(params:any) {
        try {
            console.log("Waiting for Rollup Summary workbook (" + JSON.stringify(params) + ")...")

            const data: any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/rollupWorkbook/download`, { responseType: 'arraybuffer', params }).toPromise()


            let {stage, participant} = params;

            if (stage != null) {
                if (stage.substring(0, 5) == '1e/Zb') {
                    if (participant == 'Apple' || participant == 'Google'){
                        stage = stage.replace('1e/Zb', 'Zb')
                    } else {
                        stage = stage.replace('1e/Zb', '1e')
                    }
                }
            }
            const filename = "Stage " + stage + " Rollup Summary Report - " + participant + ".xlsx";

            let blob = new Blob([data], { type: "application/ms-excel" });
            saveAs(blob, filename);

        } catch (error) {
            console.error(error)
            console.error('downloadResultsWorkbook() error: ' + error)
            this.publishError(error,this)
            throw error
        }
    }

    async downloadResultsWorkbook(filters: TableViewFilter[], suffix = '', excludeType?:boolean) {
        try {
            console.log("Waiting for Results workbook (" + JSON.stringify(filters) + ")...")
            const params: any = {}
            filters.forEach(f=>params[f.key]=f.value) // assumes all are "=" mode filters
            params['excludeType'] = excludeType

            const data: any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/resultsWorkbook/download`, { responseType: 'arraybuffer', params }).toPromise()

            console.log(JSON.stringify(filters));

            let stage = filters.find(f=>f.key=='stage')?.value
            const participant = filters.find(f=>f.key=='participant')?.value
            const buildingid =  filters.find(f=>f.key=='buildingid')?.value
            const routeid = filters.find(f=>f.key=='routeid')?.value

            if (stage != null) {
                if (stage.substring(0, 5) == '1e/Zb') {
                    if (participant == 'Apple' || participant == 'Google'){
                        stage = stage.replace('1e/Zb', 'Zb')
                    } else {
                        stage = stage.replace('1e/Zb', '1e')
                    }
                }
            }
            var filename = "Stage " + stage + " Building Report - " + buildingid + " - " + participant + suffix + ".xlsx";
            if (routeid) {
                filename = "Stage " + stage + " Drive Test Report - " + routeid + " - " + participant + suffix + ".xlsx";
            } else if (!excludeType && excludeType != null){
                console.log('Downloading Multiple reports')
                filename = "Stage " + stage + " Building Report - " + buildingid + " - " + participant +" (NextNav) "+ suffix + ".xlsx";
            }
            let blob = new Blob([data], { type: "application/ms-excel" });
            saveAs(blob, filename);

        } catch (error) {
            console.error(error)
            console.error('downloadResultsWorkbook() error: ' + error)
            this.publishError(error,this)
            throw error
        }
    }

    async runResultsWorkbookJob(filters: TableViewFilter[], suffix = '', excludeType?: boolean, browserInstanceId?: string, startDate?: string, endDate?: string) {
        try {
            console.log("Starting async Results workbook job (" + JSON.stringify(filters) + ")...")
            const params: any = {}
            filters.forEach(f => params[f.key] = f.value) // assumes all are "=" mode filters
            params['excludeType'] = excludeType
            params['userId'] = this.appState.getUser()?._id || 'unknown'
            params['userEmail'] = this.appState.getUser()?.email || 'unknown'
            if (startDate) params['startDate'] = startDate
            if (endDate) params['endDate'] = endDate

            // Use browser instance ID for websocket communication
            const clientId = browserInstanceId || Math.random().toString(36).substr(2, 9);

            const result: any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/resultsWorkbook/download`,
                {
                    params,
                    observe: 'response',
                    headers: { 'x-client-id': clientId }
                }
            ).toPromise()

            const resp = result.body
            console.log('Results workbook job started:', JSON.stringify(resp))
            return resp // Should contain jobId, status, downloadUrl, etc.
        } catch (error) {
            console.error('runResultsWorkbookJob() error: ' + error?.message)
            this.publishError(error, this)
            throw error
        }
    }

    async downloadCompletedReport(jobId: string, filters: TableViewFilter[], suffix = '') {
        try {
            const response: any = await this.httpClient.http.get(
                `${this.httpClient.urlPath}/resultsWorkbook/download/${jobId}`,
                { responseType: 'arraybuffer', observe: 'response' }
            ).toPromise()

            const data = response.body;
            let filename: string;

            // Debug: Log all available headers
            console.log('All response headers:', response.headers.keys());

            // Try to get filename from Content-Disposition header (case-insensitive)
            const contentDisposition = response.headers.get('content-disposition')
                || response.headers.get('Content-Disposition');
            console.log('Content-Disposition header:', contentDisposition);

            if (contentDisposition) {
                // Try multiple filename extraction patterns
                // Pattern 1: filename="value" or filename='value'
                let matches = /filename[^;=\n]*=["']([^"']+)["']/.exec(contentDisposition);
                // Pattern 2: filename=value (no quotes)
                if (!matches) {
                    matches = /filename[^;=\n]*=([^;\n]+)/.exec(contentDisposition);
                }
                // Pattern 3: filename*=UTF-8''value
                if (!matches) {
                    matches = /filename\*[^;=\n]*=UTF-8''([^;\n]+)/.exec(contentDisposition);
                    if (matches && matches[1]) {
                        matches[1] = decodeURIComponent(matches[1]);
                    }
                }

                if (matches && matches[1]) {
                    filename = matches[1].trim();
                    console.log('Extracted filename from header:', filename);
                }
            }

            // Fall back to constructing filename from filters if not provided by server
            if (!filename) {
                let stage = filters.find(f => f.key == 'stage')?.value
                const participant = filters.find(f => f.key == 'participant')?.value
                const buildingid = filters.find(f => f.key == 'buildingid')?.value
                const routeid = filters.find(f => f.key == 'routeid')?.value

                if (stage != null) {
                    if (stage.substring(0, 5) == '1e/Zb') {
                        if (participant == 'Apple' || participant == 'Google') {
                            stage = stage.replace('1e/Zb', 'Zb')
                        } else {
                            stage = stage.replace('1e/Zb', '1e')
                        }
                    }
                }

                filename = "Stage " + stage + " Building Report - " + buildingid + " - " + participant + suffix + ".xlsx";
                if (routeid) {
                    filename = "Stage " + stage + " Drive Test Report - " + routeid + " - " + participant + suffix + ".xlsx";
                }
            }

            let blob = new Blob([data], { type: "application/ms-excel" });
            saveAs(blob, filename);
        } catch (error) {
            console.error('downloadCompletedReport() error: ' + error)
            this.publishError(error, this)
            throw error
        }
    }

    async rebuildCorrelationDashboard() {
        try {
            const result : any = await this.httpClient.http.post(
                `${this.httpClient.urlPath}/correlationDashboard/rebuildAll`, {}, { observe: 'response' }).toPromise()
            const resp = result.body?.data
            console.log( JSON.stringify(resp))
            return resp
        } catch (error) {
            console.error('rebuildCorrelationDashboard() error: ' + error?.message )
            this.publishError(error,this)
            throw error
        }
    }


    extractErrorMsg( error: any ) {
        return this.httpClient.extractErrorMsg(error)
    }

    publishError( error:any, source:any, expireSecs = AppErrorMessageEvent.DEFAULT_EXPIRE_SECS ) {
        return this.httpClient.publishError(error,source,expireSecs)
    }

}

